import { BLOGS_PATH, LOOKBOOKS_PATH, NEWS_PATH, PRINT_PATH } from '@/consts/routes';

/** Desktop News & Media mega-menu — image cards with labels and links. */
export const NEWS_MEDIA_NAV_MEGA_MENU = {
  items: [
    {
      itemKey: 'blogs',
      label: 'Blogs',
      href: BLOGS_PATH,
      image: {
        src: '/imgs/nav/news-media/blogs.jpg',
        alt: 'NIICO blog stories and design insights',
      },
    },
    {
      itemKey: 'lookbooks',
      label: 'Lookbooks',
      href: LOOKBOOKS_PATH,
      image: {
        src: '/imgs/nav/news-media/lookbooks.jpg',
        alt: 'NIICO millwork lookbook inspiration',
      },
    },
    {
      itemKey: 'news',
      label: 'News',
      href: NEWS_PATH,
      image: {
        src: '/imgs/nav/news-media/news.jpg',
        alt: 'NIICO Millwork news and announcements',
      },
    },
    {
      itemKey: 'print',
      label: 'Print',
      href: PRINT_PATH,
      image: {
        src: '/imgs/nav/news-media/print.jpg',
        alt: 'NIICO print publications and catalogs',
      },
    },
  ],
};

/** Flat links for mobile drawer under News & Media. */
export const NEWS_MEDIA_NAV_DRAWER_LINKS = NEWS_MEDIA_NAV_MEGA_MENU.items.map(
  ({ label, href }) => ({
    label,
    href,
  }),
);

export function getNewsMediaNavHrefs() {
  return NEWS_MEDIA_NAV_MEGA_MENU.items.map(item => item.href);
}
